var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77511 2C7.33761 2 6.98295 2.33983 6.98295 2.75904C6.98295 3.17824 7.33761 3.51807 7.77511 3.51807H8.86461C8.84289 3.59894 8.83133 3.68372 8.83133 3.77108V9.85542L3.29094 18.956C2.46945 20.3054 3.48526 22 5.11562 22H18.8844C20.5147 22 21.5306 20.3054 20.7091 18.956L15.1687 9.85542V3.77108C15.1687 3.68372 15.1571 3.59894 15.1354 3.51807H16.2249C16.6624 3.51807 17.0171 3.17824 17.0171 2.75904C17.0171 2.33983 16.6624 2 16.2249 2H7.77511Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlask);
export default __webpack_public_path__ + "static/media/flask.0e1c6e6f1b87521c6045bf83a454c05f.svg";
export { ForwardRef as ReactComponent };